<template>
  <v-container fluid>
    <v-tabs fixed-tabs v-model="model">
      <v-tab key="0">
        待撥款清單
      </v-tab>

      <v-tab key="1">
        已撥款清單
      </v-tab>

      <v-tab key="2">
        問題件清單
      </v-tab>

      <v-tab key="3">
        內扣撥款清單
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="model">
      <v-tab-item key="0">
        <v-card flat>
          <v-card-text>
            <v-layout row wrap>
              <v-flex>
                <v-radio-group v-model="filterTime" row>
                  <v-radio value="0" label="今日下午"></v-radio>
                  <v-radio value="1" label="隔日上午"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <list-editor
              :column-keys="columnKeys"
              :items="items"
              :loading="loading"
              :showSearchBar="false"
              :showSearchDate="true"
              :isShowImport="false"
              :show-export-button="true"
              :searchPlaceHolder="searchPlaceHolder"
              :totalItems="getTotalItems"
              :startDate="startDate"
              :endDate="endDate"
              :sourceName="sourceName"
              :getSearchKeys="searchKeys"
              @saveData="save"
              @searchData="searchData"
              @changePage="changePage"
              @importData="importData"
              @removeData="removeData"
              @exportData="exportData"
              @openDocument="openDocument"
              @changePriorityStatus="changePriorityStatus"
            ></list-editor>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item key="1">
        <v-card flat>
          <v-card flat>
            <v-layout row wrap>
              <v-flex>
                <span class="title">{{`${startDate} ~ ${endDate}`}} 已撥款名單</span>
              </v-flex>
            </v-layout>
            <list-editor
              :column-keys="columnKeys"
              :items="items"
              :loading="loading"
              :showSearchBar="false"
              :showSearchDate="false"
              :isShowImport="false"
              :show-export-button="false"
              :searchPlaceHolder="searchPlaceHolder"
              :totalItems="getTotalItems"
              :startDate="startDate"
              :endDate="endDate"
              :sourceName="sourceName"
              :getSearchKeys="searchKeys"
              @saveData="save"
              @searchData="searchData"
              @changePage="changePage"
              @importData="importData"
              @removeData="removeData"
              @exportData="exportData"
              @openDocument="openDocument"
              @changePriorityStatus="changePriorityStatus"
            ></list-editor>
          </v-card>
        </v-card>
      </v-tab-item>

      <v-tab-item key="2">
        <v-card flat>
          <v-card flat>
<!--            <v-layout row wrap>-->
<!--              <v-flex>-->
<!--                <span class="title">問題件名單</span>-->
<!--              </v-flex>-->
<!--            </v-layout>-->
            <list-editor
              :column-keys="columnKeys"
              :items="items"
              :loading="loading"
              :showSearchBar="false"
              :showSearchDate="false"
              :isShowImport="false"
              :show-export-button="false"
              :searchPlaceHolder="searchPlaceHolder"
              :totalItems="getTotalItems"
              :startDate="startDate"
              :endDate="endDate"
              :sourceName="sourceName"
              :getSearchKeys="searchKeys"
              @saveData="save"
              @searchData="searchData"
              @changePage="changePage"
              @importData="importData"
              @removeData="removeData"
              @exportData="exportData"
              @openDocument="openDocument"
              @changePriorityStatus="changePriorityStatus"
            ></list-editor>
          </v-card>
        </v-card>
      </v-tab-item>

      <v-tab-item key="3">
        <v-card flat>
          <v-card flat>
            <list-editor
              :column-keys="appropriationKeys"
              :items="items"
              :loading="loading"
              :showSearchBar="false"
              :showSearchDate="true"
              :isShowImport="false"
              :show-export-button="true"
              :searchPlaceHolder="searchPlaceHolder"
              :totalItems="getTotalItems"
              :startDate="startDate"
              :endDate="endDate"
              :sourceName="sourceName"
              :getSearchKeys="searchKeys"
              @saveData="save"
              @editData="edit"
              @searchData="searchData"
              @changePage="changePage"
              @changeOption="changeOption"
              @importData="importData"
              @removeData="removeData"
              @exportData="exportData"
              @openDocument="openDocument"
              @changePriorityStatus="changePriorityStatus"
            ></list-editor>
          </v-card>
        </v-card>
      </v-tab-item>
    </v-tabs-items>


    <alert-view
      :visible="messageDialog.visible"
      :title="messageDialog.title"
      :content="messageDialog.text"
      :show-cancel="messageDialog.showCancelButton"
      @cancelEvent="messageDialog.cancel"
      @confirmEvent="messageDialog.confirm"
    >
    </alert-view>

    <UploadDialog :visible="showUploadDialog" @uploadFinish="uploadFinish"/>
  </v-container>
</template>

<script>
import MobileDetect from "mobile-detect";

import { mapActions, mapGetters } from "vuex";
import ListEditor from "../../components/ListEditor";
import NoticeManager from "@/utils/notice_manager";
import TableView from "@/components/TableView";
const priceData = require("../../assets/credit_price");
const cityList = require("../../assets/taiwan_city");
import { getCurrentDate, exportPriceFile, exportCCHPaymentFile, customFormatDate, getYesterday,
  getTomorrow} from '../utils/tool';
import AlertView from "../../components/AlertView";
import {
  deleteAppropriationInfo,
  getAppropriationList,
  getPaymentErrorList,
  getPaymentFinishList,
  getRequestPaymentList, updateAppropriationInfo
} from '../../store/actions';
import UploadDialog from '@/components/UploadDialog';
import common from '@/mixins/common';

export default {
  name: "RequestPaymentView",
  components: { UploadDialog, TableView, ListEditor, AlertView },
  mixins:[common],
  data() {
    return {
      filterTime: '0',
      showUploadDialog: false,
      model: 0,
      sourceName: "GrantNoticeView",
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      startDate: "",
      endDate: "",
      loading: false,
      searchKey: "status",
      searchValue: 0,
      searchPlaceHolder: "搜尋身分證、姓名、案件編號",
      items: [],
      allItems: [],
      selectItem: null,
      pagination: {
        pageList: 0,
        rowsPerPageItems: [5, 10, 50, 100],
        page: 1,
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      filter: 0,
    };
  },
  async created() {
    await this.fetchAgentList();
    this.loadData();
    const self = this;
    NoticeManager.addObserver("alertConfirm", () => {
      console.log(`this.model = ${self.model === '3'} ${self.model === 3}`);
      if (self.model === 3){
        console.log(`內扣刪除 = ${JSON.stringify(this.selectItem)}`);
        if (this.selectItem) {
          this.removeAppropriationInfo(this.selectItem.displayId);
        }
      } else {
        if (this.selectItem) {
          this.removeDataEvent(this.selectItem.recordId);
        }
      }
    });
  },
  watch:{
    model(value){
      this.pageIndex = 1;
      this.limit = 10;
      this.items = [];
      if (value === 0){
        this.loadData();
      } else if (value === 1){
        this.loadFinishData();
      } else if (value === 2){
        this.loadErrorData();
      } else if (value === 3){
        this.loadAppropriationList();
      }
    },
    filterTime(value){
      this.items = this.allItems.filter(item=>{
        if (value === '0'){
          return !this.checkAfter1030(item.requestPaymentDate);
        } else {
          return this.checkAfter1030(item.requestPaymentDate);
        }
      });
      this.totalItems = this.items.length;
    }
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentInfo", 'getAgentList']),
    canUseDelete() {
      if (
        this.getAgentInfo.agentId === "KwarcyDi4BOv75RNE5SLBOwvia32" ||
        this.getAgentInfo.agentId === "t76gyOZwV8NouQAD6WoTEH7cSzB2" ||
        this.getAgentInfo.agentId === "MXiKEOWVx8O0OxlBjab5Yro9dOr1" ||
        this.getAgentInfo.canCustomPrice === true ||
        this.isAdmin
      ) {
        return true;
      }
      return false;
    },
    columnKeys() {
      let list = [
        {
          value: "productName",
          text: "專案名稱",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "displayId",
          text: "案件編號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "name",
          text: "姓名",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "memberId",
          text: "身分證字號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "caseStatus",
          text: "案件狀態",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "caseType",
          text: "顧客評分",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "installmentsNumber",
          text: "期數",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "creditPriceMonth",
          text: "期付金",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "totalPrice",
          text: "申貸金額",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "displayName",
          text: "經銷商",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "createDate",
          text: "建立時間",
          sortable: true,
          required: false,
          disabled: true,
          isShow: true,
          isEdit: false,
        },
        { value: 'requestPaymentDate', text: '請款日期', sortable: true, required: true , isShow:true, isEdit:false},
      ];
      if (this.canUseDelete || this.getUserInfo.enableLoanhfc === true) {
        return list;
      }
      return list.filter((m) => m.value !== "delete");
    },
    appropriationKeys() {
      let list = [
        {
          value: "uploadEvent",
          text: "上傳",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "delete",
          text: "刪除",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "displayId",
          text: "案件編號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "name",
          text: "姓名",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "originAmount",
          text: "前貸金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "richPaid",
          text: "裕富已撥款",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
          options: [
            { key: false, value: '否'},
            { key: true, value: '是'}
          ]
        },
        {
          value: "isPaid",
          text: "我司已撥款",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
          options: [
            { key: false, value: '否'},
            { key: true, value: '是'}
          ]
        },
        {
          value: "bankName",
          text: "銀行名稱",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "bankSubName",
          text: "分行名稱",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "bankAccountName",
          text: "戶名",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "bankAccount",
          text: "帳號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "amount",
          text: "代墊總金額",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "fee",
          text: "通路服務費",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "total",
          text: "代扣費用總額",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "approvedPrice",
          text: "核准金額",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        {
          value: "realAmount",
          text: "實撥金額",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
        },
        { value: 'payTime1', text: '一撥日期', sortable: true, required: true , isShow:true, isEdit:false},
        { value: 'payTime2', text: '二撥日期', sortable: true, required: true , isShow:true, isEdit:false},
        {
          value: "createdDate",
          text: "建立時間",
          sortable: true,
          required: false,
          disabled: true,
          isShow: true,
          isEdit: false,
        },
      ];
      return list;
    },
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    searchKeys() {
      return [
        { key: "name", value: "姓名" },
        { key: "memberId", value: "身分證字號" },
        { key: "displayId", value: "案件編號" },
      ];
    },
    filterKeys() {
      return [
        { key: 0, value: "待處理" },
        { key: 1, value: "已處理" },
        { key: -1, value: "全部" },
      ];
    },
    getTotalItems() {
      return this.totalItems;
    },
  },
  methods: {
    ...mapActions([
      "getRequestPaymentList",
      "deleteRealPriceInfo",
      "saveMultiPriceInfo",
      "updatePriceInfoStatus",
      'getPaymentFinishList',
      'getPaymentErrorList',
      'getAppropriationList',
      'updateAppropriationInfo',
      'deleteAppropriationInfo',
      'fetchAgentList',
    ]),
    openDocument(url) {
      if (url !== "") {
        window.open(url, "_blank");
      }
    },
    changePage(page) {
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      if (this.model === 0){
        this.loadData();
      } else if (this.model === 3){
        this.loadAppropriationList();
      }
    },
    searchData(searchInfo) {
      this.searchKey = searchInfo.searchKey;
      this.startDate = searchInfo.startDate;
      this.endDate = searchInfo.endDate;
      this.searchValue = searchInfo.keyword;
      console.log(`searchData == ${JSON.stringify(searchInfo)}`);
      if (this.model === 0){
        this.loadData();
      } else if (this.model === 3){
        this.loadAppropriationList();
      }
    },
    changeFilterStatus() {
      if (this.filter === -1) {
        this.searchKey = "";
        this.filter = -1;
        this.searchValue = "";
      } else {
        this.searchKey = "status";
        this.searchValue = this.filter;
      }
      this.loadData();
    },
    async loadAppropriationList(){
      let searchQuery = [];
      if (this.searchKey && this.searchValue) {
        searchQuery.push({
          key: `${this.searchKey}`,
          value: `${this.searchValue}`,
        });
      }
      if (!this.isAdmin && !this.isStaff){
        searchQuery.push({
          key: `agentId`,
          value: `${this.getUserInfo.agentId}`,
        });
      }
      this.loading = true;
      const res = await this.getAppropriationList({
        startDate: `${this.startDate}`,
        endDate: `${this.endDate}`,
        pageIndex: this.pageIndex,
        limit: this.limit,
        searchQuery: searchQuery,
        agentId: this.isAdmin || this.isStaff ? '' : this.getUserInfo.agentId,
      });
      const result = res.data;
      this.items = [];
      console.log(`getAppropriationList == ${JSON.stringify(result)}`);
      if (result && result.statusCode === 0){
        this.items = result.data.list;
        this.totalItems = result.data.header.totalCount;
      }

      this.loading = false;
      console.log(`items === ${JSON.stringify(this.items)}`);
    },
    async loadData() {
      this.loading = true;
      const now = new Date();
      if (this.startDate === ''){
        this.startDate = getYesterday();
      }

      if (this.endDate === ''){
        this.endDate = customFormatDate(now, 'YYYY-MM-DD');
      }
      const results = await this.getRequestPaymentList({
        start: `${this.startDate} 10:30:00`,
        end: `${this.endDate} 10:30:00`,
        agentId: this.isAdmin || this.isStaff ? '' : this.getUserInfo.agentId,
      });
      if (results.status === 200) {
        this.allItems = results.data.data.list;
        this.items = [];
        for (let item of this.allItems){
          const find = this.getAgentList.find(agent=>agent.agentId===item.agentId);
          if (find){
            item.displayName = find.displayName;
          }
        }
        this.items = this.allItems.filter(item=>{
          if (this.filterTime === '0'){
            return !this.checkAfter1030(item.requestPaymentDate);
          } else {
            return this.checkAfter1030(item.requestPaymentDate);
          }
        });
        console.log(`res status === ${JSON.stringify(this.items)}`);
        this.totalItems = this.items.length;
      }
      this.loading = false;
    },
    checkAfter1030(time){
      const caseTime = new Date(time);
      const hours = caseTime.getHours();
      const minutes = caseTime.getMinutes();

      if (hours < 10 || (hours === 10 && minutes < 30)) {
        return false;
      } else {
        return true;
      }
    },
    async loadFinishData() {
      this.loading = true;
      const now = new Date();
      let today = customFormatDate(now, 'YYYY-MM-DD');
      let searchStart = `${today} 00:00:00`;
      let searchEnd = `${today} 23:59:59`;

      this.startDate = searchStart;
      this.endDate = searchEnd;

      const results = await this.getPaymentFinishList({
        start: searchStart,
        end: searchEnd,
        agentId: this.isAdmin || this.isStaff ? '' : this.getUserInfo.agentId,
      });
      if (results.status === 200) {
        this.items = results.data.data.list;
        console.log(`res status === ${JSON.stringify(this.items)}`);
        this.totalItems = results.data.data.header.totalCount;
      }
      this.loading = false;
    },
    async loadErrorData() {
      this.loading = true;
      const results = await this.getPaymentErrorList({
        agentId: this.isAdmin || this.isStaff ? '' : this.getUserInfo.agentId,
      });
      if (results.status === 200) {
        this.items = results.data.data.list;
        console.log(`res status === ${JSON.stringify(this.items)}`);
        this.totalItems = results.data.data.header.totalCount;
      }
      this.loading = false;
    },
    async importData(data) {
      let processData = [];
      let i = 0;
      for (let item of data) {
        let newItem = {};
        for (let key of Object.keys(item)) {
          if (key === "審件編號") {
            newItem["displayId"] = item[key];
          } else if (key === "撥款金額") {
            newItem["realPrice"] = item[key];
          } else if (key === "撥款日期") {
            newItem["sendDate"] = item[key];
          } else if (key === "車牌") {
            newItem["carId"] = item[key];
          }
        }
        processData.push(newItem);
        i += 1;
      }
      // console.log(`${JSON.stringify(processData)}`);

      this.loading = true;
      let title = "錯誤";
      let message = "";
      try {
        const res = await this.saveMultiPriceInfo({
          list: processData,
        });
        const saveResult = res.data;
        this.loading = false;
        if (saveResult) {
          if (saveResult.statusCode === 0) {
            title = "成功";
            await this.loadData();
          }
          console.log(JSON.stringify(saveResult));
          message = saveResult.message;
        }
      } catch (e) {
        this.loading = false;
        message = `發生錯誤 ${e}`;
      }

      NoticeManager.notifyObservers("showAlert", {
        title: "提示",
        text: message,
        visible: true,
        showCancelButton: false,
      });
    },
    exportData() {
      if (this.model === 0){
        exportPriceFile(
          `待撥款清單_${getCurrentDate()}`,
          this.columnKeys.filter(
            (m) =>
              m.value !== "delete"
          ),
          this.items
        );
      } else if (this.model === 3){
        const cols = [
          {
            value: "displayId",
            text: "案件編號",
          },
          {
            value: "promotionTypeName",
            text: "專案類型",
          },
          {
            value: "beforePrice",
            text: "內扣金額",
          },
          {
            value: "name",
            text: "姓名",
          },
          {
            value: "vendorName",
            text: "經辦",
          },
          {
            value: "bankId",
            text: "銀行代碼+分行代碼",
          },
          {
            value: "bankAccount",
            text: "帳號",
          },
          {
            value: "memberId",
            text: "身分證號",
          },
          {
            value: "amount",
            text: "金額",
          },
          {
            value: "bankAccountName",
            text: "戶名",
          },
          {
            value: "default0",
            text: "固定為0",
          },
          {
            value: "space",
            text: "",
          },
          {
            value: "default15",
            text: "固定為15",
          },
          {
            value: "comment",
            text: "備註",
          },
          {
            value: "padBankId",
            text: "銀行代碼+分行代碼",
          },
          {
            value: "padBankAccount",
            text: "帳號",
          },
          {
            value: "space",
            text: "身分證號",
          },
          {
            value: "pad",
            text: "代墊費用總額",
          },
          {
            value: "padBankAccountName",
            text: "戶名",
          },
          {
            value: "default0",
            text: "固定為0",
          },
          {
            value: "space",
            text: "",
          },
          {
            value: "default15",
            text: "固定為15",
          },
          {
            value: "space",
            text: "備註",
          },
          {
            value: "withholdingBankId",
            text: "銀行代碼+分行代碼",
          },
          {
            value: "withholdingBankAccount",
            text: "帳號",
          },
          {
            value: "space",
            text: "身分證號",
          },
          {
            value: "total",
            text: "代扣費用總額",
          },
          {
            value: "withholdingBankAccountName",
            text: "戶名",
          },
          {
            value: "default0",
            text: "固定為0",
          },
          {
            value: "space",
            text: "",
          },
          {
            value: "default15",
            text: "固定為15",
          },
          {
            value: "space",
            text: "備註",
          },
          {
            value: "withholdingBankId2",
            text: "銀行代碼+分行代碼",
          },
          {
            value: "withholdingBankAccount2",
            text: "帳號",
          },
          {
            value: "withholdingBankAccountName2",
            text: "戶名",
          },
          {
            value: "space",
            text: "身分證號",
          },
          {
            value: "secondTotal",
            text: "代扣費用總額2",
          },
          {
            value: "default0",
            text: "固定為0",
          },
          {
            value: "space",
            text: "",
          },
          {
            value: "default15",
            text: "固定為15",
          },
          {
            value: "space",
            text: "備註",
          },
        ];
        let list = [];
        for (let item of this.items){
          const newItem = {
            displayId: item.displayId,
            promotionTypeName: item.promotionNo,
            beforePrice: item.beforePrice,
            name: item.name,
            bankId : `${item.bankId}${item.bankSubId}`,
            bankAccount: item.bankAccount,
            memberId: item.memberId,
            amount: item.realAmount,
            bankAccountName: item.bankAccountName,
            default0: '0',
            space: '',
            default15: '15',
            comment: item.comment,
            pad: item.pad,
            padBankId: item.padBankId ? `${item.padBankId}${item.padBankSubId}`: '',
            padBankAccount: item.padBankAccount,
            padBankAccountName: item.padBankAccountName,
            total: item.total,
            withholdingBankId: item.withholdingBankId ? `${item.withholdingBankId}${item.withholdingBankSubId}`: '',
            withholdingBankAccount: item.withholdingBankAccount,
            withholdingBankAccountName: item.withholdingBankAccountName,
            secondTotal: item.secondTotal,
            withholdingBankId2: item.withholdingBankId2 ? `${item.withholdingBankId2}${item.withholdingBankSubId2}`: '',
            withholdingBankAccount2: item.withholdingBankAccount2,
            withholdingBankAccountName2: item.withholdingBankAccountName2,
            vendorName: item.vendorName
          }
          list.push(newItem);
        }
        exportCCHPaymentFile(`嘉好國泰撥款_${getCurrentDate()}`, cols, list);
      }
    },
    save() {},
    removeData(data) {
      this.selectItem = data;
      NoticeManager.notifyObservers("showAlert", {
        title: "提示",
        text: "是否要刪除紀錄？",
        visible: true,
        showCancelButton: true,
      });
      console.log(`remove ${JSON.stringify(data)}`);
    },
    async removeDataEvent(caseId) {
      await this.deleteRealPriceInfo({
        caseId: caseId,
      });
      await this.loadData();
    },
    async removeAppropriationInfo(displayId){
      await this.deleteAppropriationInfo({
        displayId: displayId
      });
      await this.loadAppropriationList();
    },
    async changePriorityStatus(item) {
      const res = await this.updatePriceInfoStatus({
        caseId: item.caseId,
        status: item.status,
      });
      this.showMessageDialog(
        "提示",
        "更新優撥狀態成功",
        true,
        async () => {
          this.loadData();
        },
        () => {}
      );
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    edit(item) {
      // this.editedItem = item;
      console.log(`edit == ${JSON.stringify(item)}`);
      if (item.fileURL == null){
        this.showUploadDialog = true;
      } else {
        this.openDocument(item.fileURL);
      }
      this.selectItem = item;
    },
    async changeOption(item){
      console.log(`changeOption == ${JSON.stringify(item)}`);
      const res = await this.updateAppropriationInfo(item);
      const result = res.data;
      console.log(`updateAppropriationInfo ${JSON.stringify(result)}`);
      if (result && result.statusCode === 0){
        this.showMessageDialog(
          "提示",
          "更新狀態成功",
          true,
          async () => {
            await this.loadAppropriationList();
          },
          () => {}
        );
      }
    },
    async uploadFinish(url){
      console.log(`uploadFinish = ${url}`);
      this.showUploadDialog = false;
      if (this.selectItem){
        this.selectItem.agentId = this.getUserInfo.agentId;
        this.selectItem.fileURL = url;
        await this.updateAppropriationInfo(this.selectItem);
      }
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/pages/web/RequestPaymentView.vue